export default __webpack_public_path__ + "static/media/Yuan Cargador.b7ea0610.jpg";